export default {
  nuxtServerInit({ commit }, context) {
    const growthbookPayload = context.app.$growthbookPayload
    if (growthbookPayload) {
      commit('SET_GROWTHBOOK_PAYLOAD', growthbookPayload)
    }
  },
}
